const RefundReason = {
  PRODUCT_NOT_AVAILABLE: 'product_not_available',
  REQUESTED_BY_CUSTOMER: 'requested_by_customer',
  FRAUDULENT: 'fraudulent',
  DUPLICATE: 'duplicate',
  OTHER: 'other',
};

module.exports = RefundReason;
